import React, { useState, useContext } from 'react'
import { Col, Input, Row, Button, Card, Label } from 'reactstrap'
import { LiveProdName, NewsLetterStyle } from '../../../../StyledComponents'
import Rating from 'react-rating'
import { Star } from 'react-feather'
import { ThemeColors } from '@src/utility/context/ThemeColors'
import { IoCaretBackOutline } from 'react-icons/io5'
import ImageFileUploader from '../../../Manage/ImageFileUploader'
import { BsEmojiFrown, BsEmojiNeutral, BsEmojiSmile } from 'react-icons/bs'
import Select from 'react-select'


const ReturnRefundForm = (props) => {

    const { onCancel } = props;

    const themeColors = useContext(ThemeColors)
    const [selectedRating, setSelectedRating] = useState(null)
    const [pictures, setPictures] = useState([])
    const [imgs, setImgs] = useState([])
    const [videos, setVideos] = useState([])
    const [videoFiles, setVideoFiles] = useState([])
    const [reviewText, setReviewText] = useState('')

    const ratingOptions = ['5', '4', '3', '2', '1']

    const handleRatingChange = (rating) => {
        setSelectedRating(rating)
    }

    const handleRemoveFile = (index, type) => {
        if (type === 'image') {
            const updatedImgs = imgs.filter((_, i) => i !== index)
            setImgs(updatedImgs)

            const updatedPictures = pictures.filter((_, i) => i !== index)
            setPictures(updatedPictures)
        } else if (type === 'video') {
            const updatedVideos = videos.filter((_, i) => i !== index)
            setVideos(updatedVideos)

            const updatedVideoFiles = videoFiles.filter((_, i) => i !== index)
            setVideoFiles(updatedVideoFiles)
        }
    }

    const onSubmit = () => {
        const formData = {
            rating: selectedRating,
            review: reviewText,
            pictures: pictures,
            videos: videos
        }
        console.log('Form Data:', formData)
    }

    return (
        <div>
            <Row>
                <Col xl='1' lg='1' md='1' sm='12' xs='12'>
                    <NewsLetterStyle style={{ fontSize: '18px', cursor: 'pointer' }} onClick={() => onCancel(false)}> <IoCaretBackOutline /> Back</NewsLetterStyle>
                </Col>
                <Col xl='11' lg='11' md='11' sm='12' xs='12'>
                    <div >
                        <Row style={{ display: 'flex', justifyContent: 'center' }}>
                            <Col xl='7' lg='7' md='12' sm='12' xs='12'>
                                <Card className='py-4' style={{ border: 'none' }}>
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'space-between', marginBottom: '1rem' }}>
                                        <NewsLetterStyle style={{ fontWeight: '700' }}>Return/Refund Form</NewsLetterStyle>
                                    </div>
                                    <div style={{ color: '#FBBD34', backgroundColor: '#FBFFC8', padding: '1.5rem', textAlign: 'justify' }}>Help other customers make informed decisions by sharing your insights. Please provide a detailed review of your experience with the seller. Your feedback is invaluable to us!</div>
                                    <div className='p-4'>
                                        <div>
                                            <Row>
                                                <Col xl='4' lg='4' md='4' sm='4' xs='4'>
                                                    <div>Order ID:</div>
                                                </Col>
                                                <Col xl='8' lg='8' md='8' sm='8' xs='8'>
                                                    <div>#12345</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xl='4' lg='4' md='4' sm='4' xs='4'>
                                                    <div>Product Name:</div>
                                                </Col>
                                                <Col xl='8' lg='8' md='8' sm='8' xs='8'>
                                                    <div>product name</div>
                                                </Col>
                                            </Row>
                                        </div>
                                        
                                        <div className='mb-2'>
                                            <Label><LiveProdName style={{ fontWeight: '600' }}>Reason for Return:</LiveProdName></Label>
                                            <Select placeholder='Write your additional comments' />
                                        </div>
                                        <div className='mb-2'>
                                            <Label><LiveProdName style={{ fontWeight: '600' }}>Additional Comments:</LiveProdName></Label>

                                            <Input type='textarea' value={reviewText} placeholder='Write your detailed feedback about your overall experience with seller' onChange={(e) => setReviewText(e.target.value)} />
                                        </div>
                                        <div className='mb-2'>
                                            <Label><LiveProdName style={{ fontWeight: '600' }}>Reason for Return:</LiveProdName></Label>
                                            <Select placeholder='Write your additional comments' />
                                        </div>

                                        <div className='mb-2'>
                                            <Label><LiveProdName style={{ fontWeight: '600' }}>Return Shipping Method:</LiveProdName></Label>
                                            <Select placeholder='Write your additional comments' />
                                        </div>
                                        <div className='mb-2'>
                                            <Label><LiveProdName style={{ fontWeight: '600' }}>Return Shipping Address:</LiveProdName></Label>
                                            <Input disabled='true' placeholder='Shipping Address' />
                                        </div>
                                        <div className='mb-2'>
                                <LiveProdName style={{ fontWeight: '600' }}>Attachment (Attach images or videos)</LiveProdName>
                                    <ImageFileUploader
                                        pictures={videos}
                                        setPictures={setVideos}
                                        imgs={videoFiles}
                                        setImgs={setVideoFiles}
                                        handleRemoveFile={(index) => handleRemoveFile(index, 'video')}
                                    />
                                </div>
                                <div className="mb-2">
                                    <div>Return Shipping Label</div>
                                    <div>Once your return request is accepted, you can go to the "Return Orders" in “Orders” section to download the shipping label from there.</div>
                                </div>
                                        
                                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                                            <button className='btn' color='primary' style={{ backgroundColor: '#41B8E4', color: 'white' }} onClick={onSubmit}>Submit Re</button>
                                        </div>
                                    </div>

                                </Card>
                            </Col>
                        </Row>
                    </div>
                </Col>
            </Row>
        </div>
    )
}

export default ReturnRefundForm
